// extracted by mini-css-extract-plugin
module.exports = {"root":"archive-module--root--jAOTt","posts":"archive-module--posts--3V0sF","year":"archive-module--year--2-pl4","post":"archive-module--post--1ldMe"};